import { render, staticRenderFns } from "./table-view.vue?vue&type=template&id=0809afcc&scoped=true"
import script from "./table-view.vue?vue&type=script&lang=js"
export * from "./table-view.vue?vue&type=script&lang=js"
import style0 from "./table-view.vue?vue&type=style&index=0&id=0809afcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0809afcc",
  null
  
)

export default component.exports